// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order-details-bill-no {
  display: flex;
  justify-content: space-between;
  text-align: left !important;
}

.order-details-bill-details {
  display: flex;
  justify-content: space-between;
  text-align: left;
  position: sticky !important;
  overflow: auto;
}

.order-details-bill-second {
  display: flex;
  justify-content: space-between;
  text-align: left;
  position: sticky !important;
  overflow: auto;
}

.order-details-cashier {
  display: flex;
  justify-content: flex-start;
}

.gst-slab {
  font-weight: bold !important;
  font-size: 12px !important;
  text-shadow: 0.8px 0 black;
  letter-spacing: 0.5px;
}

.order-item-list-box {
  font-size: 13px !important;
}

.orderReturnedItems {
  color: var(--red-solid);
}

.orderCompItems {
  color: var(--light-blue);
}

.order-details-divider {
  font-size: 16px !important;
  font-weight: 700;
}

.order-details-btns-main {
  display: flex;
  justify-content: space-between;
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 100;
  padding: 10px !important;
  background-color: white !important;
  border-radius: 8px;
}

.dark .order-details-btns-main {
  background-color: var(--dark-blue) !important;
}

.order-details-btns {
  background-color: rgb(1, 100, 254) !important;
}

.order-details-btns-I {
  background-color: rgb(1, 100, 254) !important;
  margin-right: 10px !important;
}

.loader-order-details-page {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
  width: 100%;
}

.dark .MuiTablePagination-displayedRows {
  color: #fff !important;
}

.dark .MuiTablePagination-actions {
  color: #fff !important;
}

.dark .MuiDataGrid-columnHeaderTitle {
  color: #fff !important;
  font-weight: 600;
  font-size: 0.8rem;
}

.light .MuiDataGrid-columnHeaderTitle {
  color: #000 !important;
  font-weight: 600;
  font-size: 0.8rem;
}

.order-details-btns-back {
  background-color: rgb(1, 100, 254) !important;
  margin-left: 10px !important;
}

.paid-text-order {
  color: green !important;
  font-weight: 600 !important;
  text-align: center !important;
}

.payment-not-done-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
}

.padding {
  padding: 10px;
}

.center {
  text-align: center;
}

.start {
  text-align: start;
}

.end {
  text-align: end;
}

.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.end-flex {
  justify-content: flex-end;
}

.right-side {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 15px;
}

.bold {
  font-weight: bold;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.flex-start {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}

.align-items-fs {
  align-items: flex-start;
}

.big-text {
  font-size: 24px;
}

.dotted-faded-hr {
  border: none;
  border-top: 2px dashed rgba(0, 0, 0, 0.2);
  /* Dotted border with 50% opacity */
}

.bill-preview {
  overflow: auto;
  width: 40%;
  margin: 45px auto 0px auto;
}

.sub-total-wrapper-container-credit-order-details {
  padding: 1px;
  border: 1px solid lightblue !important;
  background-color: var(--blue) !important;
  font-size: 13px !important;
  min-width: 3rem !important;
  margin-top: 1px;
  transition:
    background-color 0.3s ease,
    box-shadow 0.3s ease,
    transform 0.3s ease;
}

.orderDetailsButtonsContainer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: calc(100% - 165px);
  background-color: #fff;
  padding: 10px 0 10px;
  position: fixed;
  top: 90px;
  z-index: 100;
}

.orderDetailsButtonsContainerLeft {
  display: flex;
  align-items: center;
  gap: 10px;
}

.order-details-bill-details {
  background-color: #f5f5f5;
  width: 100%;
  padding: 10px 10px 5px 10px;
}

.order-details-bill-second {
  background-color: #f5f5f5;
  width: 100%;
  padding: 0px 10px 10px 10px;
}

.order-details-bill-no {
  display: flex;
  flex-direction: column;
}

.order-details-container-new {
  width: calc(98% - 1rem) !important;
  height: 100% !important;
  overflow: scroll;
  margin: 1rem 1rem 0rem 1rem;
}

.orderDetailsBasicDetails {
  margin-top: 8px;
}

.orderDetailsBasicDetailsInner {
  background-color: #fff9ea;
  padding: 10px;
}

.orderDetailsBasicDetailsInnerText {
  display: flex;
  justify-content: space-between;
}

.order-inner-table {
  border-collapse: collapse;
  width: 100%;
  border: none !important;
}

.order-inner-table th,
.order-inner-table td {
  border: none !important;
  border-bottom: 1px solid #ccc;
  padding: 8px;
  text-align: left;
}

.order-inner-table th {
  background-color: var(--surface-g0);
  border: none !important;
}

.order-inner-table th {
  background-color: var(--surface-g0);
  border: none !important;
  border-bottom: none !important;
  border-top: none !important;
}

.order-inner-table tr:last-child td {
  border-bottom: none;
}

.customer-details-bill-details-order {
  background-color: #fff9ea;
  padding: 8px;
}

.cutomer-details-bill-no {
  font-size: 14px;
  display: flex;
  justify-content: space-between;
}

.cutomer-details-bill-no-text {
  font-weight: 700;
}

/* ── Dark theme ── */
.dark .orderDetailsButtonsContainer {
  background-color: #0f172a;
}

.dark .order-details-bill-details {
  background-color: #1e293b;
  color: #f1f5f9;
}

.dark .order-details-bill-second {
  background-color: #1e293b;
  color: #f1f5f9;
}

.dark .orderDetailsBasicDetailsInner {
  background-color: #1e293b;
  color: #f1f5f9;
}

.dark .customer-details-bill-details-order {
  background-color: #1e293b;
  color: #f1f5f9;
}

.dark .dotted-faded-hr {
  border-top-color: rgba(255, 255, 255, 0.15);
}

.dark .order-inner-table th,
.dark .order-inner-table td {
  border-bottom-color: #334155;
  color: #f1f5f9;
}

.dark .order-inner-table th {
  background-color: #1e293b;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/orders/orders.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;EAC7C,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,6CAA6C;EAC7C,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,yCAAyC;EACzC,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,sCAAsC;EACtC,wCAAwC;EACxC,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;EACf;;;uBAGqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;EACf,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,uBAAuB;AACzB;;AAEA;;EAEE,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,uBAAuB;EACvB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;;EAEE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".order-details-bill-no {\n  display: flex;\n  justify-content: space-between;\n  text-align: left !important;\n}\n\n.order-details-bill-details {\n  display: flex;\n  justify-content: space-between;\n  text-align: left;\n  position: sticky !important;\n  overflow: auto;\n}\n\n.order-details-bill-second {\n  display: flex;\n  justify-content: space-between;\n  text-align: left;\n  position: sticky !important;\n  overflow: auto;\n}\n\n.order-details-cashier {\n  display: flex;\n  justify-content: flex-start;\n}\n\n.gst-slab {\n  font-weight: bold !important;\n  font-size: 12px !important;\n  text-shadow: 0.8px 0 black;\n  letter-spacing: 0.5px;\n}\n\n.order-item-list-box {\n  font-size: 13px !important;\n}\n\n.orderReturnedItems {\n  color: var(--red-solid);\n}\n\n.orderCompItems {\n  color: var(--light-blue);\n}\n\n.order-details-divider {\n  font-size: 16px !important;\n  font-weight: 700;\n}\n\n.order-details-btns-main {\n  display: flex;\n  justify-content: space-between;\n  position: sticky;\n  top: 0;\n  width: 100%;\n  z-index: 100;\n  padding: 10px !important;\n  background-color: white !important;\n  border-radius: 8px;\n}\n\n.dark .order-details-btns-main {\n  background-color: var(--dark-blue) !important;\n}\n\n.order-details-btns {\n  background-color: rgb(1, 100, 254) !important;\n}\n\n.order-details-btns-I {\n  background-color: rgb(1, 100, 254) !important;\n  margin-right: 10px !important;\n}\n\n.loader-order-details-page {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 80vh;\n  width: 100%;\n}\n\n.dark .MuiTablePagination-displayedRows {\n  color: #fff !important;\n}\n\n.dark .MuiTablePagination-actions {\n  color: #fff !important;\n}\n\n.dark .MuiDataGrid-columnHeaderTitle {\n  color: #fff !important;\n  font-weight: 600;\n  font-size: 0.8rem;\n}\n\n.light .MuiDataGrid-columnHeaderTitle {\n  color: #000 !important;\n  font-weight: 600;\n  font-size: 0.8rem;\n}\n\n.order-details-btns-back {\n  background-color: rgb(1, 100, 254) !important;\n  margin-left: 10px !important;\n}\n\n.paid-text-order {\n  color: green !important;\n  font-weight: 600 !important;\n  text-align: center !important;\n}\n\n.payment-not-done-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100px;\n}\n\n.padding {\n  padding: 10px;\n}\n\n.center {\n  text-align: center;\n}\n\n.start {\n  text-align: start;\n}\n\n.end {\n  text-align: end;\n}\n\n.flex {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.end-flex {\n  justify-content: flex-end;\n}\n\n.right-side {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 15px;\n}\n\n.bold {\n  font-weight: bold;\n}\n\n.flex-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.flex-start {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 10px;\n}\n\n.align-items-fs {\n  align-items: flex-start;\n}\n\n.big-text {\n  font-size: 24px;\n}\n\n.dotted-faded-hr {\n  border: none;\n  border-top: 2px dashed rgba(0, 0, 0, 0.2);\n  /* Dotted border with 50% opacity */\n}\n\n.bill-preview {\n  overflow: auto;\n  width: 40%;\n  margin: 45px auto 0px auto;\n}\n\n.sub-total-wrapper-container-credit-order-details {\n  padding: 1px;\n  border: 1px solid lightblue !important;\n  background-color: var(--blue) !important;\n  font-size: 13px !important;\n  min-width: 3rem !important;\n  margin-top: 1px;\n  transition:\n    background-color 0.3s ease,\n    box-shadow 0.3s ease,\n    transform 0.3s ease;\n}\n\n.orderDetailsButtonsContainer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: calc(100% - 165px);\n  background-color: #fff;\n  padding: 10px 0 10px;\n  position: fixed;\n  top: 90px;\n  z-index: 100;\n}\n\n.orderDetailsButtonsContainerLeft {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.order-details-bill-details {\n  background-color: #f5f5f5;\n  width: 100%;\n  padding: 10px 10px 5px 10px;\n}\n\n.order-details-bill-second {\n  background-color: #f5f5f5;\n  width: 100%;\n  padding: 0px 10px 10px 10px;\n}\n\n.order-details-bill-no {\n  display: flex;\n  flex-direction: column;\n}\n\n.order-details-container-new {\n  width: calc(98% - 1rem) !important;\n  height: 100% !important;\n  overflow: scroll;\n  margin: 1rem 1rem 0rem 1rem;\n}\n\n.orderDetailsBasicDetails {\n  margin-top: 8px;\n}\n\n.orderDetailsBasicDetailsInner {\n  background-color: #fff9ea;\n  padding: 10px;\n}\n\n.orderDetailsBasicDetailsInnerText {\n  display: flex;\n  justify-content: space-between;\n}\n\n.order-inner-table {\n  border-collapse: collapse;\n  width: 100%;\n  border: none !important;\n}\n\n.order-inner-table th,\n.order-inner-table td {\n  border: none !important;\n  border-bottom: 1px solid #ccc;\n  padding: 8px;\n  text-align: left;\n}\n\n.order-inner-table th {\n  background-color: var(--surface-g0);\n  border: none !important;\n}\n\n.order-inner-table th {\n  background-color: var(--surface-g0);\n  border: none !important;\n  border-bottom: none !important;\n  border-top: none !important;\n}\n\n.order-inner-table tr:last-child td {\n  border-bottom: none;\n}\n\n.customer-details-bill-details-order {\n  background-color: #fff9ea;\n  padding: 8px;\n}\n\n.cutomer-details-bill-no {\n  font-size: 14px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.cutomer-details-bill-no-text {\n  font-weight: 700;\n}\n\n/* ── Dark theme ── */\n.dark .orderDetailsButtonsContainer {\n  background-color: #0f172a;\n}\n\n.dark .order-details-bill-details {\n  background-color: #1e293b;\n  color: #f1f5f9;\n}\n\n.dark .order-details-bill-second {\n  background-color: #1e293b;\n  color: #f1f5f9;\n}\n\n.dark .orderDetailsBasicDetailsInner {\n  background-color: #1e293b;\n  color: #f1f5f9;\n}\n\n.dark .customer-details-bill-details-order {\n  background-color: #1e293b;\n  color: #f1f5f9;\n}\n\n.dark .dotted-faded-hr {\n  border-top-color: rgba(255, 255, 255, 0.15);\n}\n\n.dark .order-inner-table th,\n.dark .order-inner-table td {\n  border-bottom-color: #334155;\n  color: #f1f5f9;\n}\n\n.dark .order-inner-table th {\n  background-color: #1e293b;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
